module.exports = __webpack_public_path__ + "static/img/AU@3x.951ed63e.png";